<!--BUG REPORT:
1. Footer ul not lining up underneath image. Tried adding padding-left: 0; to the ul class, but didn't work.
-->

<!--NAVBAR-->
<nav class="navbar navbar-expand-lg navbar-light bg-white navbar-style fixed-top shadow">
    <a rel="#" class="navbar-brand">
        <img src="assets/company-logos/EazyBreezyLogoTopBanner.png" height="100" alt="EazyBreezyHC">
    </a>
    <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
        <span class="navbar-toggler-icon"></span> <!--toggle not working-->
    </button> 
    <div class="collapse navbar-collapse" id="navbarCollapse">
        <div class="navbar-nav ml-auto">
            <a routerLink="/" href="/" class="nav-item nav-link active">Home</a>
            <a routerLink="/about" href="/about" class="nav-item nav-link">About</a>
            <div class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" data-toggle="dropdown">Services</a>
                <div class="dropdown-menu">
                    <a routerLink="/heating" href="/heating" class="dropdown-item">Heating</a>
                    <a routerLink="/cooling" href="/cooling" class="dropdown-item">Cooling</a>
                    <a routerLink="/plumbing" href="/plumbing" class="dropdown-item">Plumbing</a>
                </div>
            </div>
            <a routerLink="/heat-pumps" href="/heat-pumps" class="nav-item nav-link">Heat Pumps</a>
            <a routerLink="/contact" href="/contact" class="nav-item nav-link">Contact</a>
        </div>
    </div>
</nav>


<router-outlet></router-outlet>

<!--FOOTER-->
<footer class="bg-black">
    <div class="container-fluid">
        <div class="container">
            <div class="row pt-3 pb-3">
                <div class="col-sm-12 col-md-4 d-flex justify-content-center center-360 pt-1">
                    <a href="https://www.financeit.ca/s/Z32VIA"><img src="../assets/company-logos/FinanceIt.jpg" alt="Click to Finance It"></a>
                    <!--<a rel="#" class="footer-logo">
                        <img src="assets/site-theme/EazyBreezyHC-white.png" height="120" alt="Eazy Breezy HC">
                    </a>-->
                </div>
                <div class="col-sm-12 col-md-4 d-flex justify-content-center center-360 mobile-pt">
                    
                    <ul class="footer-text text-center text-white">
                        <li><img class="footer-logo" src="assets/site-theme/EazyBreezyHC-white.png" height="60" alt="Eazy Breezy HC"></li>
                        <li>Phone: 587-596-3040</li>
                        <li>Email: info@eazybreezyhc.com</li>
                        <li>Servicing: Edmonton, AB<br>&amp; surrounding area</li>
                        <li>Mon-Fri &nbsp; 8:00 AM-5:00 PM</li>
                    </ul>
                </div>
                <div class="col-sm-12 col-md-4 mobile-pt">
                    <div class="text-white">
                        <!--<div class="d-flex justify-content-center pt-5">
                            <img src="../assets/company-logos/Coleman.png" alt="Coleman Heating and Air Conditioning">
                        </div>-->
                        <div class="d-flex justify-content-center pt-4">
                            <img src="../assets/company-logos/DucaneLogo.jpg" alt="Ducane Air Conditioning and Heating">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pt-1 pb-1">
            <div class="col-12 text-grey-medium text-center">
                <p>Copyright © 2023 Eazy Breezy HC | Powered by <span class="text-bold">Wired Programming</span></p>
            </div>
        </div>
    </div>
</footer>


